<template>
  <svg width="7"
       height="11"
       viewBox="0 0 7 11"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path d="M5.03906 10.3711L1.12891 6.21484C1.01953 6.07812 0.9375 5.91406 0.9375 5.75C0.9375 5.61328 1.01953 5.44922 1.12891 5.3125L5.03906 1.15625C5.28516 0.882812 5.69531 0.882812 5.96875 1.12891C6.24219 1.375 6.24219 1.78516 5.99609 2.05859L2.46875 5.77734L5.99609 9.46875C6.24219 9.74219 6.24219 10.1523 5.96875 10.3984C5.69531 10.6445 5.28516 10.6445 5.03906 10.3711Z"
          fill="currentColor" />
  </svg>
</template>